import * as React from 'react';
import { Route } from 'react-router';
import { usePermissions } from 'permissions';
import { useUser } from 'features/auth';
import { useIsAuthenticated } from 'features/auth';

/**
 * Connected component which receives current authenticated user
 */
function isAllowed(props) {
  const { permissions } = props;

  const { canViewVideos, isSuperAdmin } = usePermissions();

  const isAuthenticated = useIsAuthenticated();

  const user = useUser({ requiredAuth: false });

  return (
    permissions.length === 0 ||
    permissions.some((permission) => {
      switch (permission.scope) {
        case 'guest':
          return isAuthenticated === false;

        case 'authenticated':
          return isAuthenticated === true;

        case 'superadmin':
          return user.railsUserData && isSuperAdmin();

        case 'can-view-videos':
          return user.railsUserData && canViewVideos();

        default:
          return false;
      }
    })
  );
}

export const AuthState = function AuthState(props) {
  return props.render(isAllowed(props));
};
